import { render, staticRenderFns } from "./FacebookReactionsFont.vue?vue&type=template&id=76046176&"
import script from "./FacebookReactionsFont.vue?vue&type=script&lang=js&"
export * from "./FacebookReactionsFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports